const INSTALLATION_ID_STORAGE_KEY = "chekhabare.push.installation_id.v1";

const fallbackRandomId = () => {
  const randomPart = Math.random().toString(36).slice(2);
  const timePart = Date.now().toString(36);
  return `ckh-${timePart}-${randomPart}-${Math.random().toString(36).slice(2)}`;
};

const createInstallationId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return fallbackRandomId();
};

export const getPushInstallationId = () => {
  if (typeof window === "undefined") return "";

  try {
    const current = window.localStorage.getItem(INSTALLATION_ID_STORAGE_KEY);
    if (current && current.length >= 16 && current.length <= 128) {
      return current;
    }

    const next = createInstallationId();
    window.localStorage.setItem(INSTALLATION_ID_STORAGE_KEY, next);
    return next;
  } catch {
    /*
     * Storage can be unavailable in hardened/private contexts. Keep a valid
     * per-page identifier rather than breaking the app; persistent push setup
     * should only proceed when storage is available.
     */
    return fallbackRandomId();
  }
};

export const detectPushPlatform = () => {
  if (typeof navigator === "undefined") return "web";

  const userAgent = String(navigator.userAgent || "").toLowerCase();
  if (/iphone|ipad|ipod/.test(userAgent)) return "ios";
  if (/android/.test(userAgent)) return "android";
  return "web";
};

export const getPushCapability = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return { supported: false, permission: "unsupported" };
  }

  const supported =
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window;

  return {
    supported,
    permission: supported ? Notification.permission : "unsupported",
  };
};
